import { ScrollView, Alert } from "react-native";
import { useRouter } from "expo-router";
import { View, Text } from "@src/components";
import { Icon } from "@src/components/Icon";
import { useUnistyles } from "react-native-unistyles";
import { isWeb } from "@src/utils/web-helpers";
import LegacyKit from "modules/legacy-kit";
import * as ScreenOrientation from "expo-screen-orientation";
import { PressableScale } from "pressto";

type MenuItem = {
  id: string;
  title: string;
  onPress: () => void;
};

export default function DevelopmentScreen() {
  const router = useRouter();
  const { theme } = useUnistyles();

  const handleOpenLegacyCamera = async () => {
    try {
      // Unlock orientation to allow legacy app to control portrait/landscape
      await ScreenOrientation.unlockAsync();

      // @ts-expect-error baseline 2026-02-16
      await LegacyKit.openCameraViewController();
    } catch (error) {
      Alert.alert("Error", `Failed to open legacy camera: ${error}`);
      // Lock back to portrait if there's an error
      await ScreenOrientation.lockAsync(ScreenOrientation.OrientationLock.PORTRAIT_UP);
    }
  };

  const menuItems: MenuItem[] = [
    {
      id: "legacy-camera",
      title: "Legacy Camera (POC)",
      onPress: handleOpenLegacyCamera,
    },
    {
      id: "theme-demo",
      title: "Theme Demo",
      onPress: () => router.push("/development/theme-demo"),
    },
    {
      id: "feature-flags",
      title: "Feature Flags",
      onPress: () => router.push("/development/feature-flags"),
    },
    {
      id: "environment",
      title: "Environment",
      onPress: () => router.push("/development/environment"),
    },
    {
      id: "logout",
      title: "Logout",
      onPress: () => router.push("/auth/logout"),
    },
    {
      id: "biometrics",
      title: "Pin & Biometrics",
      onPress: () => router.push("/auth/biometrics"),
    },
    {
      id: "activity-notification",
      title: "Activity Notification",
      onPress: () => router.push("/contacts/activity-notification"),
    },
    {
      id: "site-alarm",
      title: "Site Alarm",
      onPress: () => router.push("/contacts/site-alarm"),
    },
    {
      id: "clips",
      title: "Clips (requires organisation/camera context)",
      onPress: () => router.push("/overview"),
    },
    {
      id: "toast",
      title: "Toast",
      onPress: () => router.push("/development/components/toast"),
    },
    {
      id: "legacy-login",
      title: "Legacy Login",
      onPress: () => router.push("/auth/login"),
    },
    {
      id: "forgot-password",
      title: "Forgot Password",
      onPress: () => router.push("/auth/forgot-password"),
    },
    {
      id: "camera-details",
      title: "Camera Details",
      onPress: () => router.push("/development/camera-debug"),
    },
  ];

  // Filter out biometrics and legacy-camera on web
  const filteredMenuItems = menuItems.filter((item) => {
    if ((item.id === "biometrics" || item.id === "legacy-camera") && isWeb) {
      return false;
    }
    return true;
  });

  return (
    <View flex={1} bg="background">
      <ScrollView style={{ flex: 1 }} contentContainerStyle={{ padding: 20, paddingBottom: 40 }}>
        {/* Menu Items */}
        <View mb="6xl">
          {filteredMenuItems.map((item) => (
            <PressableScale
              key={item.id}
              style={{
                flexDirection: "row",
                alignItems: "center",
                paddingVertical: theme.spacing["3xl"],
                paddingHorizontal: theme.spacing.xl,
                borderBottomWidth: 1,
                borderBottomColor: theme.colors.border,
              }}
              onPress={item.onPress}
            >
              <Text textStyle="md/medium" style={{ flex: 1 }}>
                {item.title}
              </Text>
              <Icon name="chevronRight" size={theme.spacing["5xl"]} color={theme.colors.textMuted} />
            </PressableScale>
          ))}
        </View>
      </ScrollView>
    </View>
  );
}
